/* eslint-disable react/no-unstable-nested-components */
import {
  Accordion, AccordionDetails, AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import i18n from '../common/i18n';
import { route } from '../navigation/routes';
import { ORIGINACION_WT } from '../../api/env';
import safeGetEnv from '../../prerender';

const HomeFaqSection = () => {
  const ORIGINACION_WT_LINK = safeGetEnv(ORIGINACION_WT);

  const accordionStyle = {
    border: 'none',
    borderBottom: '2px groove #ccc',
    boxShadow: 'none',
    '&::before': {
      display: 'none',
    },
  };

  return (
    <Box sx={{
      width: '85%',
      margin: 'auto',
      marginTop: '16px',
      marginBottom: '16px',
    }}
    >
      <Typography variant="h3" fontWeight={700} className="lettersGrey" mt={5} mb={4}>{i18n.faq}</Typography>

      <Accordion sx={accordionStyle}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h5" sx={{ fontFamily: 'Open Sans !important' }}>{i18n.homeFirstQuestion}</Typography>
        </AccordionSummary>
        <AccordionDetails className="textLeft">
          <Typography component="p" fontSize={18} sx={{ fontFamily: 'Open Sans !important' }}>
            {i18n.homeFirstAnswerOne}
            <a
              href={ORIGINACION_WT_LINK}
              target="_blank"
              rel="noopener noreferrer nofollow"
              style={{ textDecoration: 'none', color: 'inherit' }}
              className="lettersMagentaNew"
            >
              {i18n.homeAnswerCTAOrigination}
            </a>
            {i18n.homeFirstAnswerTwo}
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={accordionStyle}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h5" sx={{ fontFamily: 'Open Sans !important' }}>{i18n.homeSecondQuestion}</Typography>
        </AccordionSummary>
        <AccordionDetails className="textLeft">
          <Typography component="p" fontSize={18} sx={{ fontFamily: 'Open Sans !important' }}>
            {i18n.homeSecondAnswerOne}
            <a
              href={ORIGINACION_WT_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
              className="lettersMagentaNew"
            >
              {i18n.homeAnswerCTAOrigination}
            </a>
            {i18n.homeSecondAnswerTwo}
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={accordionStyle}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h5" sx={{ fontFamily: 'Open Sans !important' }}>{i18n.homeThirdQuestion}</Typography>
        </AccordionSummary>
        <AccordionDetails className="textLeft">
          <Typography component="p" fontSize={18} sx={{ fontFamily: 'Open Sans !important' }}>
            {i18n.homeThirdAnswer}
            <a
              href={ORIGINACION_WT_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
              className="lettersMagentaNew"
            >
              {i18n.homeAnswerCTAOriginationHere}
            </a>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={accordionStyle}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h5" sx={{ fontFamily: 'Open Sans !important' }}>{i18n.homeFourQuestion}</Typography>
        </AccordionSummary>
        <AccordionDetails className="textLeft">
          <Typography component="p" fontSize={18} sx={{ fontFamily: 'Open Sans !important' }}>
            {i18n.homeFourAnswer}
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Typography variant="h5" sx={{ fontFamily: 'Open Sans !important' }} fontWeight={600} mt={6} mb={6}>
        {i18n.homeMoreQuestion}
        <a
          href={route.help}
          fontWeight={600}
          className="lettersMagentaNew"
        >
          {i18n.homeLinkHelp}
        </a>
      </Typography>
    </Box>
  );
};

export default HomeFaqSection;
